import axios from "./axiosInstance";
import CryptoUtils from "../util/cryptoUtils";
import { Globals } from "../global/Globals";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(({ resolve, reject, originalRequest }) => {
    if (error) {
      reject(error);
    } else {
      originalRequest.headers["Authorization"] = `Bearer ${token}`;
      resolve(axios(originalRequest));
    }
  });
  failedQueue = [];
};

const refreshToken = async () => {
  const token = CryptoUtils.getFromLocalStorage("refreshToken");
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };


  const endpoint= "/Authenticate/RefreshToken";
  return await axios.post(endpoint,JSON.stringify(token), config);
};
 

// ✅ Modified refreshAccessToken: handles both proactive and failed request scenarios
export const refreshAccessToken = (originalRequest = null, showPopupCallback) => {
  return new Promise((resolve, reject) => {
    // if (originalRequest) {
    //   failedQueue.push({ resolve, reject, originalRequest });
    // }

    // if (!isRefreshing) {
    //   isRefreshing = true;
    //   refreshToken()
    //     .then((res) => {
    //       const Token = res.data.content.token;
    //       const newRefreshToken = res.data.content.refreshToken;
    //       CryptoUtils.saveToLocalStorage("refreshToken", newRefreshToken);

    //       CryptoUtils.saveToCookie(
    //         Globals.JWT_TOKEN_NAME,
    //         Token,
    //         Globals.JWT_TOKEN_EXPIRY
    //       );

    //       processQueue(null, Token);

    //       if (!originalRequest) {
    //         resolve(Token); // proactive refresh (IdleTimer onActive)
    //       }
    //     })
    //     .catch((err) => {
    //       const status = err?.response?.status;

    //       if (!err.response && window.location.pathname !== "/") {
    //         document.body.classList.add("hide-loader");
    //         showPopupCallback?.(true);
    //       }
    //       if (status === 401 && window.location.pathname !== "/") {
    //         document.body.classList.add("hide-loader");
    //         showPopupCallback?.(true);
    //       }

    //       processQueue(err, null);

    //       if (!originalRequest) {
    //         reject(err); // proactive refresh (IdleTimer onActive)
    //       }
    //     })
    //     .finally(() => {
    //       isRefreshing = false;
    //     });
    // } else if (!originalRequest) {
    //   // No originalRequest and already refreshing → resolve when the queue resolves
    //   const interval = setInterval(() => {
    //     if (!isRefreshing) {
    //       clearInterval(interval);
    //       resolve(); // Resolve when refresh completes
    //     }
    //   }, 100);
    // }
  });
};
